import {
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconInfo,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPlug,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
  IconUpload,
} from '@assets/images/icon';
import { IconAnalyze, IconTopology, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { vehicleTrackingKit1, vehicleTrackingKit5, yardTrackingKit1, yardTrackingKit4 } from '@assets/images/main/outdoor';

export default {
  a: [
    { text: 'Phương thức kỹ thuật', icon: IconInfo },
    { text: 'Độ chính xác vị trí', icon: IconSignal },
    { text: 'Tần suất truyền dữ liệu', icon: IconUpload },
    { text: 'Cấu trúc liên kết', icon: IconTopology },
    { text: 'Nguồn điện đầu vào', icon: IconPlug },
    { text: 'Môi trường đề xuất', icon: IconBookmark },
    { text: 'Điểm nổi bật', icon: IconPencil },
    { text: 'Kết nối bên ngoài', icon: IconShare },
  ],

  b: [
    { text: 'Định vị GPS dựa trên GNSS' },
    { text: '±3 mét' },
    { text: 'Tối đa 30 lần/phút' },
    { text: 'Thiết bị GPS (LTE) → ORBRO Server' },
    { text: 'USB-C' },
    { text: 'Theo dõi vị trí xe cộ, theo dõi vị trí tài sản' },
    { text: 'Có thể thu thập thông tin vị trí chỉ với một thiết bị đầu cuối' },
    { text: 'Cung cấp API' },
  ],

  c: [
    { text: 'Nhận tín hiệu GPS dựa trên LoRa' },
    { text: '±3 mét' },
    { text: 'Tối đa 120 lần/phút' },
    { text: 'Tag GPS → Bộ thu LoRa → ORBRO Server' },
    { text: 'PoE' },
    { text: 'Bãi chứa, cảng, trung tâm logistics, công trường xây dựng, v.v.' },
    { text: 'Thu tín hiệu từ nhiều thẻ trong khu vực cụ thể,<br/>không tốn phí truyền thông' },
    { text: 'Cung cấp API (tích hợp sự kiện/vị trí/trạng thái theo thời gian thực)' },
  ],

  spec: [
    {},

    {
      image: vehicleTrackingKit5,
      link: '/outdoor/gps',
      title: 'Thiết bị GPS',
      desc: '',
    },

    {
      image: yardTrackingKit4,
      link: '/outdoor/lora',
      title: 'Thẻ GPS (LoRA)',
      desc: '',
    },
  ],
};
